import { mapGetters } from 'vuex';
import isNil from 'lodash/isNil';

export default {
  computed: {
    ...mapGetters(['getWorkScheduleByExternalCode']),
  },
  methods: {

    getWorkScheduleExternalNameBySchedule(workSchedule) {
      if (isNil(workSchedule) || (workSchedule && !(workSchedule.externalCode))) {
        return this.$t('misc.none');
      }

      const ws = this.getWorkScheduleByExternalCode(workSchedule.externalCode);
      if (workSchedule.type === 'WORK_SCHEDULE' && ws) {
        return ws.externalName;
      }
      return workSchedule.externalCode;
    },

    getWorkScheduleExternalNameByCode(externalCode) {
      if (!externalCode) {
        return this.$t('misc.none');
      }

      const ws = this.getWorkScheduleByExternalCode(externalCode);
      if (ws) {
        return ws.externalName;
      }
      return externalCode;
    },
  },
};
